import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './firstBlock.module.scss';
import phoneScreen from 'src/assets/img/landing/phoneScreen.png';
import handBackground from 'src/assets/img/landing/hand.png';
import { ReactComponent as TestPlusLametri } from 'src/assets/img/landing/testPlusLametri.svg';
import { Helmet } from 'react-helmet-async';

const FirstBlock = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <div className={styles.imageContainer}>
        <Left />
        <Right />
      </div>
    </CommonLandingContainer>
  );
};

export default FirstBlock;

const Left = () => {
  return (
    <>
      <Helmet>
        <link rel="preload" href={handBackground} as="image" />
        <link rel="preload" href={phoneScreen} as="image" />
      </Helmet>
      <div className={styles.left}>
        <TestPlusLametri className={styles.testPlusLametri} />
      </div>
    </>
  );
};

const Right = () => {
  return (
    <div className={styles.right}>
      <div className={styles.imageContainer222}>
        <img
          fetchpriority="high"
          className={styles.phoneScreen}
          src={phoneScreen}
          alt="Результат анализа"
        />
      </div>
    </div>
  );
};
